var $699d6a98c8e7642a$exports = {};
$699d6a98c8e7642a$exports = {
    "maximum": `\u{39C}\u{3AD}\u{3B3}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`,
    "minimum": `\u{395}\u{3BB}\u{3AC}\u{3C7}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`
};


export {$699d6a98c8e7642a$exports as default};
//# sourceMappingURL=el-GR.mjs.map
